export default (value) => {
  switch (value) {
    case 0:
      return 'Regular User';
    case 1:
      return 'Viewer Admin';
    case 2:
      return 'Admin';
    case 3:
      return 'Super Admin';
    default:
      return 'N/A';
  }
};
